// extracted by mini-css-extract-plugin
export var darkMode = "_1c-0";